import { render, staticRenderFns } from "./LoginComponentLayout.vue?vue&type=template&id=7f2284f8&scoped=true&"
import script from "./LoginComponentLayout.vue?vue&type=script&lang=ts&"
export * from "./LoginComponentLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LoginComponentLayout.vue?vue&type=style&index=0&id=7f2284f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2284f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
